<template>
    <div class="container offset">
        <form>
            <div class="custom-form ">
                <div class="form-group">
                    <label class="question-style pt-1">Nome:</label>
                    <input v-model="memberInfo.nome" type="name" class="form-control input-personal disabled-style" />
                </div>

                <div class="form-group">
                    <label class="question-style pt-1">Email:</label>
                    <input v-model="memberInfo.email" type="email" class="form-control input-personal disabled-style" />
                </div>

                <!-- <div class="form-group">
                    <label class="question-style pt-1">Data de Nascimento:</label>
                    <input
                        v-model="membroById.dataNascimento"
                        type="date"
                        class="form-control input-personal disabled-style"
                    />
                </div>

                <div class="form-group">
                    <label class="question-style pt-1">Telefone:</label>
                    <input 
                        v-model="membroById.telefone" 
                        type="text"
                        class="form-control input-personal disabled-style"
                    />
                </div> -->

                <div class="form-group">
                    <label class="question-style pt-1">Cargo atual:</label>
                    <input v-model="memberInfo.permissao" type="name" class="form-control input-personal disabled-style" />
                </div>

                <div class="form-group" v-if="memberInfo.nome_regional != null">
                    <label class="question-style pt-1">Regional:</label>
                    <input v-model="memberInfo.nome_regional" type="text"
                        class="form-control input-personal disabled-style" />
                </div>

                <div class="form-group" v-if="memberInfo.nome_municipio != null">
                    <label class="question-style pt-1">Município:</label>
                    <input v-model="memberInfo.nome_municipio" type="text"
                        class="form-control input-personal disabled-style" />
                </div>

                <div class="form-group" v-if="memberInfo.nome_ue != null">
                    <label class="question-style pt-1">Unidade Educacional:</label>
                    <input v-model="memberInfo.nome_ue" type="text"
                        class="form-control input-personal disabled-style" />
                </div>
            </div>
        </form>
        <div class="button-div d-flex flex-row-reverse justify-content-between mt-5">
            <Button @click="close" section="descartar" value="Fechar" :isOutline="true" :hasIcon="true" iconName="times" />
        </div>
    </div>
</template>

<script>
import Button from '../../components/Button';

export default {
    name: "show_member_info",
    components: {
        Button
    },
    data() {
        return {
            memberInfo: {},
        };
    },
    props: {
        data: Object,
    },
    computed: {
        userPerm() {
            return this.$store.getters.getUserPerm;
        },
        membroById() {
            return this.$store.getters.getMemberById;
        },
    },
    watch: {
        async data() {
            this.memberInfo = this.$props.data;
            this.$store.dispatch("setMemberById", this.data.id);
        },
    },
    methods: {
        close() {
            this.$emit('closeModal')
        },
    },
    async created() {
    }
};
</script>

<style scoped>
.container {
    width: 100%;
    background-color: white;
}

.form-group {
    display: flex;
}

.title-style {
    font-size: 1.5rem;
    font-weight: 600;
    color: #656565;
}

.question-style {
    width: 100%;
    font-size: 1rem;
    font-weight: 500;
    color: #656565;
}

.image-style {
    display: block;
    margin-left: auto;
    margin-right: auto;
    width: 50%;
    padding: 1rem;
}

.button-div {
    margin-top: 2rem;
}

.input-personal {
    padding: 0.2rem 0.4rem;
    font-size: 0.938rem;
    font-weight: 400;
    border-radius: 8px;
    background: #FCFCFC;
    outline: none;
    border: 1px solid rgba(0, 0, 0, 0.11);
    font-weight: lighter;
    padding: 0.2rem 0.4rem;
    box-shadow: 1px 2px 6px -3px rgb(0 0 0 / 25%);
}

.disabled-style {
    background-color: #D0D0D0 !important;
    cursor: default;
    pointer-events: none;
}
</style>